var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "EditTable" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticClass: "tabel-warp"
        },
        [
          _c(
            "vxe-table",
            {
              ref: "vxeTable",
              attrs: {
                align: "center",
                border: "",
                data: _vm.tabelData,
                "column-config": _vm.columnConfig,
                "row-config": { isHover: true },
                round: "",
                size: "small",
                "tooltip-config": {
                  showAll: true
                },
                stripe: "",
                "edit-config": _vm.editConfig,
                "keep-source": "",
                "edit-rules": _vm.vxeRules,
                height: "100%"
              }
            },
            [
              _c("vxe-column", {
                attrs: {
                  field: "PO_NO",
                  title: "采购单号",
                  "min-width": "200",
                  "edit-render": { enabled: _vm.canEdit }
                },
                scopedSlots: _vm._u([
                  {
                    key: "edit",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("vxe-input", {
                          attrs: { type: "text", disabled: true },
                          model: {
                            value: row.PO_NO,
                            callback: function($$v) {
                              _vm.$set(row, "PO_NO", $$v)
                            },
                            expression: "row.PO_NO"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("vxe-column", {
                attrs: {
                  field: "PART_NO",
                  title: "物料编码",
                  "min-width": "160",
                  "edit-render": { enabled: _vm.canEdit }
                },
                scopedSlots: _vm._u([
                  {
                    key: "edit",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("vxe-input", {
                          attrs: { type: "text", disabled: true },
                          model: {
                            value: row.PART_NO,
                            callback: function($$v) {
                              _vm.$set(row, "PART_NO", $$v)
                            },
                            expression: "row.PART_NO"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("vxe-column", {
                attrs: {
                  field: "PART_NAME",
                  title: "物料名称",
                  "min-width": "200",
                  "edit-render": { enabled: _vm.canEdit }
                },
                scopedSlots: _vm._u([
                  {
                    key: "edit",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("vxe-input", {
                          attrs: { type: "text", disabled: true },
                          model: {
                            value: row.PART_NAME,
                            callback: function($$v) {
                              _vm.$set(row, "PART_NAME", $$v)
                            },
                            expression: "row.PART_NAME"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("vxe-column", {
                attrs: {
                  field: "PART_DESCR",
                  title: "规格描述",
                  "min-width": "180",
                  "show-overflow": "ellipsis",
                  "edit-render": { enabled: _vm.canEdit }
                },
                scopedSlots: _vm._u([
                  {
                    key: "edit",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("vxe-input", {
                          attrs: { type: "text", disabled: true },
                          model: {
                            value: row.PART_DESCR,
                            callback: function($$v) {
                              _vm.$set(row, "PART_DESCR", $$v)
                            },
                            expression: "row.PART_DESCR"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("vxe-column", {
                attrs: {
                  field: "PO_REMAINING_QTY",
                  title: "可交量",
                  "min-width": "120",
                  "edit-render": { enabled: _vm.canEdit }
                },
                scopedSlots: _vm._u([
                  {
                    key: "edit",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("vxe-input", {
                          attrs: { type: "text", disabled: true },
                          model: {
                            value: row.PO_REMAINING_QTY,
                            callback: function($$v) {
                              _vm.$set(row, "PO_REMAINING_QTY", $$v)
                            },
                            expression: "row.PO_REMAINING_QTY"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("vxe-column", {
                attrs: {
                  field: "DELIVERY_QTY",
                  title: "送货数量",
                  "min-width": "130",
                  "edit-render": {
                    enabled: _vm.canEdit,
                    autofocus: ".vxe-input--inner"
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "edit",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("vxe-input", {
                          attrs: { type: "number", disabled: false },
                          model: {
                            value: row.DELIVERY_QTY,
                            callback: function($$v) {
                              _vm.$set(row, "DELIVERY_QTY", $$v)
                            },
                            expression: "row.DELIVERY_QTY"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("vxe-column", {
                attrs: {
                  field: "SPQ",
                  title: "内箱包装数量",
                  "min-width": "150",
                  "edit-render": {
                    enabled: _vm.canEdit,
                    autofocus: ".vxe-input--inner"
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "edit",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("vxe-input", {
                          attrs: { type: "number", disabled: false },
                          model: {
                            value: row.SPQ,
                            callback: function($$v) {
                              _vm.$set(row, "SPQ", $$v)
                            },
                            expression: "row.SPQ"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("vxe-column", {
                attrs: {
                  field: "PACKING_QTY",
                  title: "外箱装箱数量",
                  "min-width": "120",
                  "edit-render": {
                    enabled: _vm.canEdit,
                    autofocus: ".vxe-input--inner"
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "edit",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("vxe-input", {
                          attrs: { type: "number", disabled: false },
                          model: {
                            value: row.PACKING_QTY,
                            callback: function($$v) {
                              _vm.$set(row, "PACKING_QTY", $$v)
                            },
                            expression: "row.PACKING_QTY"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("vxe-column", {
                attrs: {
                  field: "PO_ITEM",
                  title: "采购项次",
                  "min-width": "120",
                  "edit-render": {
                    enabled: _vm.canEdit,
                    autofocus: ".vxe-input--inner"
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "edit",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("vxe-input", {
                          attrs: { type: "number", disabled: true },
                          model: {
                            value: row.PO_ITEM,
                            callback: function($$v) {
                              _vm.$set(row, "PO_ITEM", $$v)
                            },
                            expression: "row.PO_ITEM"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("vxe-column", {
                attrs: {
                  field: "VENDOR_PART_NO",
                  title: "供应商料号",
                  "min-width": "180",
                  "edit-render": {
                    enabled: _vm.canEdit,
                    autofocus: ".vxe-input--inner"
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "edit",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("vxe-input", {
                          attrs: { type: "text", disabled: false },
                          model: {
                            value: row.VENDOR_PART_NO,
                            callback: function($$v) {
                              _vm.$set(row, "VENDOR_PART_NO", $$v)
                            },
                            expression: "row.VENDOR_PART_NO"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("vxe-column", {
                attrs: {
                  field: "DATE_CODE",
                  title: "生产日期",
                  "min-width": "150",
                  "edit-render": {
                    enabled: _vm.canEdit,
                    autofocus: ".vxe-input--inner"
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "edit",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("vxe-input", {
                          attrs: {
                            type: "date",
                            placeholder: "请选择日期",
                            transfer: ""
                          },
                          model: {
                            value: row.DATE_CODE,
                            callback: function($$v) {
                              _vm.$set(row, "DATE_CODE", $$v)
                            },
                            expression: "row.DATE_CODE"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("vxe-column", {
                attrs: {
                  field: "LOT_NO",
                  title: "批次号",
                  "min-width": "130",
                  "edit-render": {
                    enabled: _vm.canEdit,
                    autofocus: ".vxe-input--inner"
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "edit",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("vxe-input", {
                          attrs: { type: "text", disabled: false },
                          model: {
                            value: row.LOT_NO,
                            callback: function($$v) {
                              _vm.$set(row, "LOT_NO", $$v)
                            },
                            expression: "row.LOT_NO"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("vxe-column", {
                attrs: {
                  field: "ATTRIBUTE9",
                  title: "重量",
                  "min-width": "100",
                  "edit-render": {
                    enabled: _vm.canEdit,
                    autofocus: ".vxe-input--inner"
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "edit",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("vxe-input", {
                          attrs: { type: "number", disabled: false },
                          model: {
                            value: row.ATTRIBUTE9,
                            callback: function($$v) {
                              _vm.$set(row, "ATTRIBUTE9", $$v)
                            },
                            expression: "row.ATTRIBUTE9"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("vxe-column", {
                attrs: {
                  field: "ATTRIBUTE8",
                  title: "颜色",
                  "min-width": "100",
                  "edit-render": {
                    enabled: _vm.canEdit,
                    autofocus: ".vxe-input--inner"
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "edit",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("vxe-input", {
                          attrs: { type: "text", disabled: false },
                          model: {
                            value: row.ATTRIBUTE8,
                            callback: function($$v) {
                              _vm.$set(row, "ATTRIBUTE8", $$v)
                            },
                            expression: "row.ATTRIBUTE8"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("vxe-column", {
                attrs: {
                  field: "PO_UNIT",
                  title: "采购单位",
                  "min-width": "100",
                  "edit-render": {
                    enabled: _vm.canEdit,
                    autofocus: ".vxe-input--inner"
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "edit",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("vxe-input", {
                          attrs: { type: "text", disabled: true },
                          model: {
                            value: row.PO_UNIT,
                            callback: function($$v) {
                              _vm.$set(row, "PO_UNIT", $$v)
                            },
                            expression: "row.PO_UNIT"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("vxe-column", {
                attrs: {
                  field: "BASE_UNIT",
                  title: "基本单位",
                  "min-width": "100",
                  "edit-render": {
                    enabled: _vm.canEdit,
                    autofocus: ".vxe-input--inner"
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "edit",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("vxe-input", {
                          attrs: { type: "text", disabled: true },
                          model: {
                            value: row.BASE_UNIT,
                            callback: function($$v) {
                              _vm.$set(row, "BASE_UNIT", $$v)
                            },
                            expression: "row.BASE_UNIT"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("vxe-column", {
                attrs: {
                  field: "UNIT_EXRATE",
                  title: "转换比例",
                  "min-width": "130",
                  "edit-render": {
                    enabled: _vm.canEdit,
                    autofocus: ".vxe-input--inner"
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "edit",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("vxe-input", {
                          attrs: { type: "text", disabled: true },
                          model: {
                            value: row.UNIT_EXRATE,
                            callback: function($$v) {
                              _vm.$set(row, "UNIT_EXRATE", $$v)
                            },
                            expression: "row.UNIT_EXRATE"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("vxe-column", {
                attrs: {
                  field: "PO_TOTAL_QTY",
                  title: "PO采购数量",
                  "min-width": "120",
                  "edit-render": {
                    enabled: _vm.canEdit,
                    autofocus: ".vxe-input--inner"
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "edit",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("vxe-input", {
                          attrs: { type: "text", disabled: true },
                          model: {
                            value: row.PO_TOTAL_QTY,
                            callback: function($$v) {
                              _vm.$set(row, "PO_TOTAL_QTY", $$v)
                            },
                            expression: "row.PO_TOTAL_QTY"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("vxe-column", {
                attrs: {
                  field: "DESCRIPTION",
                  title: "备注",
                  "min-width": "200",
                  "edit-render": {
                    enabled: _vm.canEdit,
                    autofocus: ".vxe-input--inner"
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "edit",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("vxe-input", {
                          attrs: { type: "text", disabled: false },
                          model: {
                            value: row.DESCRIPTION,
                            callback: function($$v) {
                              _vm.$set(row, "DESCRIPTION", $$v)
                            },
                            expression: "row.DESCRIPTION"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("vxe-column", {
                attrs: {
                  field: "ATTRIBUTE1",
                  title: "采购员",
                  "min-width": "100",
                  "edit-render": {
                    enabled: _vm.canEdit,
                    autofocus: ".vxe-input--inner"
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "edit",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("vxe-input", {
                          attrs: { type: "text", disabled: true },
                          model: {
                            value: row.ATTRIBUTE1,
                            callback: function($$v) {
                              _vm.$set(row, "ATTRIBUTE1", $$v)
                            },
                            expression: "row.ATTRIBUTE1"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _vm.isShowOptionColumn
                ? _c("vxe-column", {
                    attrs: {
                      field: "",
                      title: "操作",
                      "min-width": "100",
                      fixed: "right"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  staticClass: "cancellationButton",
                                  attrs: { type: "primary", size: "small" },
                                  on: {
                                    click: function($event) {
                                      return _vm.hanldeDelete(scope.row)
                                    }
                                  }
                                },
                                [_vm._v("删除")]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      4157547706
                    )
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c("addOrderRowDialog", {
        ref: "addOrderRowDialog",
        attrs: { isShowaddOrderRowDialog: _vm.isShowaddOrderRowDialog },
        on: {
          closeaddOrderRowDialog: _vm.closeaddOrderRowDialog,
          cbDialogSubmit: _vm.cbaddOrderRowDialogSubmit
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }